export default __webpack_public_path__ + "static/media/close-24px.53c9f4b6.svg";